import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  beforeSend: (event, hint) => {
    if (process.env.NODE_ENV === "development") {
      return null;
    }
    return event;
  },
  enabled: process.env.NODE_ENV === "production",
  environment: process.env.NODE_ENV,

  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#sendDefaultPii
  sendDefaultPii: true,

  integrations: [],
});
